import { Typography } from '@mui/material';

/** Figma 10040:6763 — HOW TO USE section title */
export default function HowToUseTitle() {
  return (
    <Typography
      component="h2"
      sx={{
        fontFamily: 'Inter, sans-serif',
        fontWeight: 500,
        fontSize: 24,
        lineHeight: '32px',
        letterSpacing: '0.8px',
        color: '#7000b9',
        textAlign: 'center',
        textShadow: '0 4px 4px rgba(0, 0, 0, 0.1)',
        whiteSpace: 'nowrap',
        mb: 2.5,
      }}
    >
      HOW TO USE
    </Typography>
  );
}
